import { LOCAL_STORAGE_KEY } from '../constants/common'

export const setDeviceKey = (username, value) => {
  localStorage.setItem(LOCAL_STORAGE_KEY.DEVICE_KEY + username, value)
}

export const getDeviceKey = (username) => {
  return localStorage.getItem(LOCAL_STORAGE_KEY.DEVICE_KEY + username) || null
}

export const setAuthTime = (username, value) => {
  localStorage.setItem(LOCAL_STORAGE_KEY.AUTH_TIME + username, value)
}

export const getAuthTime = (username) => {
  return localStorage.getItem(LOCAL_STORAGE_KEY.AUTH_TIME + username) || null
}

export const setKickedDevice = (value) => {
  localStorage.setItem(LOCAL_STORAGE_KEY.KICKED_DEVICE, value)
}

export const getKickedDevice = () => {
  return localStorage.getItem(LOCAL_STORAGE_KEY.KICKED_DEVICE) || null
}
